// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx actions
import { setCustomPDFReportBuilderStore } from '../custom-pdf-report-builder/custom-pdf-report-builder.action';
import { setReportId } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/report-id/report-id.action';
export const report_id = createReducer(null, on(setReportId, setCustomPDFReportBuilderStore, (state, action) => {
    return action.report_id;
}));
